import reportRegimeHelper from "../helpers/report/reportRegime/reportRegimeHelper";

const reportRegime: { [key: string]: any } =()=>{
    return Object.fromEntries(reportRegimeHelper.getRegimes());
};

const reportRegimesWithoutDeprecated:{ [key: string]: any } =()=>{
    return Object.fromEntries(reportRegimeHelper.getRegimesWithoutDeprecated());
}

export { reportRegime, reportRegimesWithoutDeprecated };
